import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout'
import Login from '@/views/Login'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export const fixedRoutes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history',
  // base: '/fe-agent-client',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: fixedRoutes
})

const router = createRouter()

export default router
